import { useState } from "react";
import { toast } from "sonner";
import { Field, SubmitButton } from "@/components/forms/Field";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, formatDate } from "@/lib/api";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const rows = [["Name", user?.name], ["Login", user?.email], ["Role", user?.role], ["Email verified", user?.email_verified ? "Yes" : "No"], ["Member since", formatDate(user?.created_at)]];
  return (
    <div className="max-w-3xl space-y-8" data-testid="account-page">
      <div>
        <p className="eyebrow text-ds-plum">Account</p>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight">Your account</h1>
      </div>
      <section className="rounded-[24px] bg-white border border-ds-plum/10 divide-y divide-[#E9DFE7]">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between gap-4 px-6 py-4 text-sm"><span className="text-ds-inksoft">{k}</span><span className="font-semibold text-right break-all" data-testid={`account-${k.toLowerCase().replace(/\s+/g, "-")}`}>{v}</span></div>
        ))}
      </section>
      <section className="rounded-[24px] bg-white border border-ds-plum/10 p-6">
        <h2 className="font-display text-xl font-semibold">Change password</h2>
        <form onSubmit={submit} className="mt-5 grid gap-5 sm:max-w-md" data-testid="change-password-form">
          <Field id="cur" label="Current password" type="password" required value={form.current_password} onChange={set("current_password")} testId="current-password-input" />
          <Field id="new" label="New password" type="password" required minLength={8} value={form.new_password} onChange={set("new_password")} testId="new-password-input" hint="At least 8 characters with a letter and a number." />
          <Field id="conf" label="Confirm new password" type="password" required value={form.confirm} onChange={set("confirm")} testId="confirm-password-input" />
          <SubmitButton busy={busy} testId="change-password-submit">Update password</SubmitButton>
        </form>
      </section>
    </div>
  );
}
